import { InternalStepOption } from '@booking-booster-client/models';

export const step1: InternalStepOption = {
  anchorId: 'advanced-parameters',
  stepId: 'advanced-parameters',
  titleTranslationKey: 'ui_tours.settings_advertisers_parameters.step1.title',
  contentTranslationKey:
    'ui_tours.settings_advertisers_parameters.step1.content',
  route: 'settings/advertisements/paramethers',
};
